// A staging field marked from_clientverse is one the client leaves empty:
// ClientVerse fills it — a Salesforce record id written back after a load
// (sf_*_id), or a value ClientVerse works out itself, such as the fiscal-year
// flags. An admin sets the marking per field; every place a client reads the
// staging schema shows it the same way, so the wording lives here.
import type { CSSProperties } from 'react';

export const FROM_CLIENTVERSE_LABEL = 'From ClientVerse';
export const FROM_CLIENTVERSE_HINT = 'ClientVerse fills this field. Leave it empty when you load your staging data.';
/** One line for exports, where there is no tooltip. */
export const FROM_CLIENTVERSE_NOTE = 'From ClientVerse: filled by ClientVerse; leave it empty.';

export const fromClientverseChip: CSSProperties = {
  display: 'inline-block', padding: '1px 6px', fontSize: 11, borderRadius: 4,
  background: '#e3f4f1', color: '#0b5d53', border: '1px solid #a9d9cf', fontWeight: 600, whiteSpace: 'nowrap',
};

/** Row tint for a from-ClientVerse field in a table. */
export const FROM_CLIENTVERSE_TINT = '#f4fbf9';
